import { useQuery } from '@apollo/client';
import type { Maybe } from 'graphql/jsutils/Maybe';

import type { Asset2TranscodeInfo, GetAssets2TranscodingFailureQuery } from '../../../../apis/graphql';
import type { Nullable } from '../../../../models';
import { GET_ASSETS2_TRANSCODING_FAILURE } from '../../hooks/queries';

interface UseTranscodingFailureProps {
  assetId?: Nullable<string>;
}

interface UseTranscodingFailureResult {
  name: string;
  message: string;
}

type CombinedTranscodingQueryType = GetAssets2TranscodingFailureQuery;

export default function useTranscodingFailure({ assetId }: UseTranscodingFailureProps): UseTranscodingFailureResult {
  const queryResult = useQuery<CombinedTranscodingQueryType>(GET_ASSETS2_TRANSCODING_FAILURE, {
    variables: { assetId },
    skip: !assetId,
  });

  const data = queryResult?.data;

  function extractNameAndMessage(result: Maybe<Asset2TranscodeInfo>): { name: string; message: string } {
    if (result) {
      return {
        name: result.failureMessage ?? '',
        message: result.message ?? '',
      };
    }

    return { name: '', message: '' };
  }

  const rawResult = data?.getAssets2TranscodingFailure;

  return extractNameAndMessage(rawResult);
}
